import React from 'react'
import Typography from '@mui/material/Typography'
import Grid from '@mui/material/Grid'
import Box from '@mui/material/Box'
import PropTypes from 'prop-types'

import MoneyField from '~/components/Fields/MoneyField'

import FilterLocationFields from '../../Fields/FilterLocationFields'

function StorageFixed ({ name }) {
  return (
    <>
      <Typography gutterBottom={true}>Conditions</Typography>
      <FilterLocationFields name={name} />

      <Box mt={2}>
        <Typography gutterBottom={true}>Pricing</Typography>
        <Grid container={true}>

          <Grid item={true} xs={12} lg={4}>
            <MoneyField name={`${name}.price`} label="Price" />
          </Grid>

        </Grid>
      </Box>
    </>
  )
}

StorageFixed.propTypes = {
  name: PropTypes.string.isRequired
}

export default StorageFixed
